import type { Action, GameState, MoveReview } from '@ic/engine';
import { settings } from './store';

let worker: Worker | null = null;
let nextId = 0;
const pending = new Map<number, (r: MoveReview | null) => void>();

function get(): Worker {
  if (!worker) {
    worker = new Worker(new URL('../workers/review.worker.ts', import.meta.url), { type: 'module' });
    worker.onmessage = (e: MessageEvent<{ id: number; review: MoveReview | null }>) => {
      pending.get(e.data.id)?.(e.data.review);
      pending.delete(e.data.id);
    };
  }
  return worker;
}

/** Rate a move in the background. Resolves to null when move feedback is off or the move can't be rated. */
export function requestReview(before: GameState, action: Action): Promise<MoveReview | null> {
  if (!settings.get().moveFeedback) return Promise.resolve(null);
  const id = ++nextId;
  return new Promise((resolve) => {
    pending.set(id, resolve);
    get().postMessage({ id, before, action });
  });
}
